import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      fr: {
        translation: fr,
      },
    },
    // No explicit `lng`: it would win over the detector on every page load and,
    // worse, i18next re-caches it — so the user's choice was overwritten back
    // to the default on each reload. French stays the default through
    // `fallbackLng` when nothing has been stored yet.
    fallbackLng: "fr",
    supportedLngs: ["en", "fr"],
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
